import React, { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";

import { Label, TextBox, TextArea, DatePiker } from "modules/primitives";
import styles from "./styles.module.scss";
import { getPlantsAndAreas } from "modules/admin/adminPlantsAndAreas/adminPlantsAndAreas.actions";
import PlantSingleSelect from "../../../../common/components/plantSingleselect";
import UserMultiSelectSearch from "../../../../common/components/usersSearch";
import ReplicationProjectThemes from "modules/projects/project/replicateProject/replicationProjectThemes";

const PrintingReplication = ({ formikprops }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const {
    adminPlantsAndAreasReducer: { plantsAndAreas },
  } = useSelector((state) => state);

  useEffect(() => {
    if (!plantsAndAreas.length) {
      dispatch(
        getPlantsAndAreas({
          enqueueSnackbar,
        }),
      );
    }
  }, [plantsAndAreas]);

  const getPlantsAsOptions = useCallback((filterBy) => {
    const makePlants = plantsAndAreas.map(plant => ({
      id: plant.id,
      name: plant.attributes.name,
      areas: plant.attributes.areas,
    }));
    const { values } = formikprops;
    const existingValue = values[filterBy];

    if (filterBy === 'selectedPlant' && existingValue?.id) {
      return makePlants.filter(plant => existingValue.id !== plant.id);
    }

    if (filterBy === 'selectedPlant1' && existingValue?.length) {
      return makePlants.filter(plant => !existingValue.some(p => p.id === plant.id));
    }

    return makePlants;
  }, [plantsAndAreas, formikprops.values]);

  return (
    <div className="d-flex flex-column w-100">
      <div className="mb-2">
        <Label>Description</Label>
        <TextArea
          type="text"
          name="description"
          placeholder="Describe the problem you are trying to solve, the project goal, or description."
          className="w-100"
          formProps={formikprops}
          rows={4}
        />
      </div>
      <div className="mb-3">
        <PlantSingleSelect formikprops={formikprops} plants={getPlantsAsOptions("selectedPlant1")} />
        {
          !formikprops?.values?.selectedPlant?.id && (
            <div className={styles.invalidFeedback}>Plant is required</div>
          )
        }
      </div>
      <div className="mb-3">
        <ReplicationProjectThemes
          name="Innovation Pillar"
          handleSelect={(themes) => {
            formikprops.setFieldValue("themes", themes);
          }}
          themes={formikprops.values.themes || []}
        />
      </div>
      <div className="mb-3">
        <Label>Implementation Date</Label>
        <DatePiker
          name="implementation_date"
          value={formikprops.values.implementation_date}
          onChange={(val) => formikprops.setFieldValue("implementation_date", val)}
          showTime
          withClear
        />
      </div>
      <div className="mb-3">
        <Label>Original Part Reference</Label>
        <TextBox
          type="text"
          placeholder="Original Part Reference"
          className="w-100"
          value={formikprops.values.original_part_reference}
          onChange={(e) =>
            formikprops.setFieldValue("original_part_reference", e.target.value)
          }
        />
      </div>
      <div className="mb-3">
        <Label>Replication Part Reference</Label>
        <TextBox
          type="text"
          placeholder="Replication Part Reference"
          className="w-100"
          value={formikprops.values.replication_part_reference}
          onChange={(e) =>
            formikprops.setFieldValue("replication_part_reference", e.target.value)
          }
        />
      </div>
      <div className="mb-3">
        <Label>Select Project Owner</Label>
        <UserMultiSelectSearch
          multi={false}
          placeholder="Search for project owner"
          labelField="full_name"
          valueField="id"
          searchBy="full_name"
          hasAll={false}
          onChange={(value) => {
            formikprops.setFieldValue("project_owners", value);
          }}
          preselectCurrentUser
        />
        {formikprops.errors["project_owners"] && (
          <div className={styles.invalidFeedback}>{formikprops.errors['project_owners']}</div>
        )}
      </div>
    </div>
  );
};

export default PrintingReplication;
